import gql from "graphql-tag";

export const addWallet = gql`mutation addWallet($amount: Float!, $currency: String!, $paymentMethod: String,$paymentType:Int!, $orderId:String,$bookingId:String,$paymentCurrency:String) {
    addWallet(amount: $amount, currency: $currency, paymentMethod: $paymentMethod, paymentType:$paymentType, orderId:$orderId,bookingId:$bookingId,paymentCurrency:$paymentCurrency) {
            status
            errorMessage
            walletBalance
            requireAdditionalAction
            paymentIntentSecret
            redirectURL
    }
}`

export const confirmPaymentIntent = gql`mutation confirmPaymentIntent(
    $paymentIntentId: String,
    $cardLastFour: String,
    $amount: Float,
    $currency: String
) {
    confirmPaymentIntent(
        paymentIntentId: $paymentIntentId,
        cardLastFour: $cardLastFour,
        amount: $amount,
    currency: $currency
    ) {
        status
        errorMessage
    }
}`